import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  ActivitiesServiceProxy,
  ActivityDaysServiceProxy,
  ClearWorkPlanExecutionForActivityDayInput,
  UpdateWorkPlanExecutionForActivityDayInput,
  VarianceFromPlanType,
  WorkPlanExecutionEditDto,
} from '@shared/service-proxies/service-proxies';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from '@node_modules/rxjs';
import { take, takeUntil } from '@node_modules/rxjs/operators';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-variance-from-plan',
  templateUrl: './variance-from-plan.component.html',
  styleUrls: ['./variance-from-plan.component.less'],
})
export class VarianceFromPlanComponent
  extends AppComponentBase
  implements OnInit, AfterViewInit {
  @ViewChild('reasonSelector', { static: true }) reasonSelector: MatSelect;

  @Input() activityDayId;
  @Input() variancesFromPlanReasons;
  @Input() varianceFromPlan: VarianceFromPlanType;
  @Input() workPlanExecution;
  @Input() controlDisabled: boolean;


  @Output() onVarianceUpdated: EventEmitter<any> = new EventEmitter<any>();

  public reasonsFormCtrl: FormControl = new FormControl();
  public reasonsFilterFormCtrl: FormControl = new FormControl();
  public filteredReasons: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  protected _onDestroy = new Subject<void>();

  reason: number = -1;

  id = Math.random();

  constructor(
    injector: Injector,
    private _activitiesServiceProxy: ActivitiesServiceProxy,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.workPlanExecution) {
      this.reason = this.workPlanExecution.varianceType??-1;
      this.reasonsFormCtrl.setValue(
        this.workPlanExecution.varianceFromPlanReasons.slice()
      );
    } else {
      this.reasonsFormCtrl.setValue(this.variancesFromPlanReasons.slice());
    }

    if(this.variancesFromPlanReasons){
      this.filteredReasons.next(this.variancesFromPlanReasons.slice());
    }

    this.reasonsFilterFormCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterReasons();
      });

    this.onVarianceUpdated.emit(this.workPlanExecution?.varianceType);
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.setInitialReasonsSelectorValue();
  }

  setInitialReasonsSelectorValue() {
    this.filteredReasons
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.reasonSelector.compareWith = (a: any, b: any) => {
          return a && b && a.varianceFromPlanReason.id === b.id;
        };
      });
  }

  protected filterReasons() {
    if (!this.variancesFromPlanReasons) {
      return;
    }

    let search = this.reasonsFilterFormCtrl.value;
    if (!search) {
      this.filteredReasons.next(this.variancesFromPlanReasons.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredReasons.next(
        this.variancesFromPlanReasons.filter(
          (item) =>
              item.varianceFromPlanReason.name
                  .toLowerCase()
                  .indexOf(search) > -1
          )
    );
  }

  saveSelectedReasons() {
    if(this.reasonsFormCtrl.value.length > 0) {
        const params = new UpdateWorkPlanExecutionForActivityDayInput({
        activityDayId: this.activityDayId,
        workPlan: new WorkPlanExecutionEditDto({
            varianceFromPlanReasons: this.reasonsFormCtrl.value.map(
            (item) => item.varianceFromPlanReason.id
            ),
            varianceType: this.reason,
        }),
        });
        this._activityDaysServiceProxy
        .updateWorkPlanExecution(params)
        .subscribe(() => {
            this.cdr.detectChanges();

            this.onVarianceUpdated.emit(params.workPlan.varianceType);

            abp.event.trigger('evt.refreshAllowedActions');
        });
    }
  }

  setNoneWorkPlan() {
    const params = new UpdateWorkPlanExecutionForActivityDayInput({
      activityDayId: this.activityDayId,
      workPlan: new WorkPlanExecutionEditDto({
        varianceFromPlanReasons: null,
        varianceType: 0,
      }),
    });
    this._activityDaysServiceProxy
      .updateWorkPlanExecution(params)
      .subscribe(() => {
        this.cdr.detectChanges();

        this.onVarianceUpdated.emit(params.workPlan.varianceType);

        abp.event.trigger('evt.refreshAllowedActions');
      });
  }

  resetWorkPlan(option: number, selectedOption: number) {
    if (option === selectedOption) return;
    const params = new ClearWorkPlanExecutionForActivityDayInput({
      activityDayId: this.activityDayId,
    });
    this._activityDaysServiceProxy
      .clearWorkPlanExecution(params)
      .subscribe(() => {
        this.reasonsFormCtrl.reset();
        this.cdr.detectChanges();

        this.onVarianceUpdated.emit(null);

        abp.event.trigger('evt.refreshAllowedActions');
      });
  }
}
